module.exports = __webpack_public_path__ + "img/team-icon.322fd466.png";